package com.eladfinish.bible.contest.utils

/**
 * Range of integers, from startFrom, exclusive of stopAt.
 */
fun range(startFrom: Int, stopAt: Int): List<Int> = (startFrom until stopAt).toList()

/**
 * Range of integers, from startFrom, until stopAt (inclusive).
 */
//fun range2(startFrom: Int, stopAt: Int): List<Int> = (startFrom..stopAt).toList()
